module.exports = __webpack_public_path__ + "img/cpu.930e8da7.svg";